export const normalizePath = (path: string): string => {
    if (!path) {
        return '/';
    }

    const trimmed = path.replace(/\/+$/, '');
    return trimmed === '' ? '/' : trimmed;
};

export const decodeSegment = (segment: string): string => {
    try {
        return decodeURIComponent(segment);
    } catch (_error) {
        return segment;
    }
};

export const decodePath = (path: string): string => {
    try {
        return decodeURI(path);
    } catch (_error) {
        return path;
    }
};

export const pathsAreEqual = (first: string, second: string): boolean => {
    return decodePath(normalizePath(first)) === decodePath(normalizePath(second));
};

export const splitNormalizedPath = (path: string): string[] => {
    const normalized = normalizePath(path);
    return normalized === '/' ? [''] : normalized.split('/');
};

export const joinPathWithKey = (baseUrl: string, key: string): string => {
    const trimmedBase = baseUrl.replace(/\/+$/, '');
    const trimmedKey = key.replace(/^\/+/, '');

    if (!trimmedKey) {
        return trimmedBase || '/';
    }

    if (!trimmedBase || trimmedBase === '') {
        return `/${trimmedKey}`;
    }

    return `${trimmedBase}/${trimmedKey}`;
};
